define('SuiteDynamics.HomePageHeroVideo.Entrypoint',
	[
		'SuiteDynamics.HomePageHeroVideo.HeroVideo',
		'SuiteDynamics.HomePageHeroVideo.PromoVideo'
	],
	function (
		HeroVideo,
		PromoVideo
	)
{
	'use strict';

	return  {
		mountToApp: function(container) {
			HeroVideo.mountToApp(container);
			PromoVideo.mountToApp(container);
		}
	};
});
